import Immutable from 'immutable';
import { createSelectorCreator, defaultMemoize } from 'reselect';

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, Immutable.is);
